import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import WhereMemoriesBegin from "./sections/WhereMemoriesBegin";
import TheCelebrationItinerary from "./sections/TheCelebrationItinerary";
import TheRhythmOfCaparica from "./sections/TheRhythmOfCaparica";
import StartYourJourney from "./sections/StartYourJourney";
import Footer from "@/reusable_sections/Footer";
import Location from "./sections/Location";
export default function HomePage() {
  return <div>
      <Header />
      <WhereMemoriesBegin />
      <TheCelebrationItinerary />
      <Location />
      <TheRhythmOfCaparica />
      <Footer />
    </div>;
}